import { AuthRoutes } from '@template/utils';
const AuthorizationModule = () => import(/* webpackChunkName: "authorization-module" */ './views/Module.vue');
const LandingPage = () => import(/* webpackChunkName: "landing-page" */ './views/LandingPage.vue');
const Login = () => import(/* webpackChunkName: "landing-page" */ './components/Login.vue');
const SignUp = () => import(/* webpackChunkName: "landing-page" */ './components/SignUp.vue');
const ForgetPassword = () => import(/* webpackChunkName: "landing-page" */ './components/ForgetPassword.vue');

const AuthorizationRoutes = {
    path: '',
    component: AuthorizationModule,
    children: [
        {
            path: '',
            name: 'LandingPage',
            component: LandingPage
        },
        {
            path: 'login',
            name: 'Login',
            component: AuthRoutes(LandingPage,Login)
        },
        {
            path: 'register',
            name: 'SignUp',
            component: AuthRoutes(LandingPage,SignUp)
        },
        {
            path: 'forgot-password',
            name: 'ForgotPassword',
            component: AuthRoutes(LandingPage,ForgetPassword)
        },
    ]
};

export default AuthorizationRoutes;